import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { MFE_IDENTIFIER } from '@price-pages-agency-cards/src/constants';
import DE_TRANSLATIONS from '@price-pages-agency-cards/src/locales/de/translation.json';
import EN_TRANSLATIONS from '@price-pages-agency-cards/src/locales/en/translation.json';
import FR_TRANSLATIONS from '@price-pages-agency-cards/src/locales/fr/translation.json';
import NL_TRANSLATIONS from '@price-pages-agency-cards/src/locales/nl/translation.json';
import { sendAnalytics } from '@price-pages-agency-cards/src/presentation/helpers/tracking';
import { useAgencyStore } from '@price-pages-agency-cards/src/presentation/hooks/useAgencyHook';
import { generateAVItemPricePages } from '@shared-utils/helpers/tracking';
import { useLoadTranslations } from '@shared-utils/hooks/useLoadTranslations';
import { AV_LIST_NAME, AV_ZONE, TRACKING_EVENT_TYPE } from '@shared-utils/types/analytics.types';
import SidePanelCard from '../SidePanelCard/SidePanelCard';
import { SidePanelSkeleton } from '../SidePanelSkeleton';
const SidePanelCardList = () => {
    useLoadTranslations(MFE_IDENTIFIER, {
        de: DE_TRANSLATIONS,
        en: EN_TRANSLATIONS,
        fr: FR_TRANSLATIONS,
        nl: NL_TRANSLATIONS,
    });
    const { t } = useTranslation(MFE_IDENTIFIER);
    const getRecommendedAgencies = useAgencyStore((state) => state.getRecommendedAgencies);
    const isFetchRecommendedAgenciesLoading = useAgencyStore((state) => state.isFetchRecommendedAgenciesLoading);
    const agencies = getRecommendedAgencies();
    const lastZipCode = useAgencyStore((state) => state.lastZipCode);
    const avItems = agencies.map((agency, index) => generateAVItemPricePages(agency, AV_LIST_NAME.PRICE_MAP_RECOMMENDED_AGENCY_SIDE, index));
    useEffect(() => {
        if (agencies.length && !isFetchRecommendedAgenciesLoading) {
            sendAnalytics({
                av_geolocation_level: '%av_geolocation_level%',
                av_items: avItems,
                av_zone: AV_ZONE.PRICE_SIDE_PANEL,
                event: TRACKING_EVENT_TYPE.VIEW_ITEM_LIST,
            });
        }
    }, [agencies.length, avItems, isFetchRecommendedAgenciesLoading]);
    if (isFetchRecommendedAgenciesLoading)
        return _jsx(SidePanelSkeleton, {});
    if (!agencies.length)
        return null;
    return (_jsxs(Box, { children: [_jsx(Box, { marginBottom: "spacing.24", typography: "typography.headline.20.bold", children: t('wlac_pricepages_head_title') }), agencies.map((agency, index) => (_jsx(SidePanelCard, { agency: agency, index: index, lastZipCode: lastZipCode, nbOfAgencies: agencies.length }, agency.id)))] }));
};
export default SidePanelCardList;
